export default __webpack_public_path__ + "assets/SafeConnect-6a77c8fe609cf76af7df0569d4445c88.png";